'use strict';

var Joi = require('joi');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var DashboardPageView = Joi__default["default"].object().keys({
  page_name: Joi__default["default"].string().required().description('The name of the page, or tab, the creator is on')
}).description('Tracks when what page a user is on, based on if the url changes.').meta({
  name: 'DashboardPageView',
  filename: 'dashboard:page_view.model'
});
var DashboardPageView$1 = DashboardPageView;

module.exports = DashboardPageView$1;
//# sourceMappingURL=page_view.model.js.map
